import { createFileRoute } from '@tanstack/react-router';

import { PublisherBrowse } from '@/module/Publisher';

export const Route = createFileRoute('/_auth/publisher/_publisher/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <PublisherBrowse />;
}
